import { render } from "./PillAnswers.vue?vue&type=template&id=2051df38"
import script from "./PillAnswers.vue?vue&type=script&lang=js"
export * from "./PillAnswers.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__